// extracted by mini-css-extract-plugin
export var attachment = "_mz-a";
export var emailContainer = "_mz-4";
export var emailContentPaddedContainer = "_mz-b";
export var emailHeader = "_mz-6";
export var emailIframe = "_mz-3";
export var emailInfoIcon = "_mz-9";
export var emailShortenedSummary = "_mz-e";
export var infoDropdown = "_mz-0";
export var infoRowBoundedContent = "_mz-d";
export var internal = "_mz-5";
export var merchant = "_mz-8";
export var messageInputContainer = "_mz-h";
export var normal = "_mz-7";
export var replyCard = "_mz-f";
export var subtleButton = "_mz-1";
export var subtleButtonIconContainer = "_mz-2";
export var toggleViewRepliesButton = "_mz-c";
export var wrappingText = "_mz-g";